module.exports = __webpack_public_path__ + "static/media/red-dot.9442f2f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/red-dot.png
// module id = 1198
// module chunks = 0